import React from 'react';
import '../Css/Contact.css';
import hr_line from '../Images/hr_line2.png';
import {GiVibratingSmartphone} from 'react-icons/gi';
import {IoLocationOutline,IoMailOpenOutline} from 'react-icons/io5';
import {ImInstagram} from 'react-icons/im';
import {FaFacebookSquare,FaLinkedinIn} from 'react-icons/fa'
import { SlideLeft } from './LazyShow';
const Contact = () => {
  return (
    <div className='contact_sec' id='contact'>
        <div className='section_heading'>
            <h2>Contact US</h2>
            <img src={hr_line}/>
        </div>
        <div className='content_wrapper'>
            <div className='form_container'>
                <div className='contact-detail-wrapper'>
                    <SlideLeft>
                        <div className='contact-detail-sec'>
                            <h3 className='contact-heading'>Contact Us</h3>
                            <div className='detail_wrapper'>
                                <IoLocationOutline/>
                                <p><a href='#'>100, RPS, Sheikh Sarai Phase-1, New Delhi, Delhi-110017</a></p>
                            </div>
                            <div className='detail_wrapper'>
                                <IoMailOpenOutline/>
                                <p><a href='mailto:shb.bca@gmail.com'>shb.bca@gmail.com</a></p>
                            </div>
                            <div className='detail_wrapper'>
                            <GiVibratingSmartphone/>
                                <p><a href='tel:+91-9716279387'>tel:+91-9716279387</a></p>
                            </div>
                            <div className='socials'>
                                <ImInstagram/>
                                <FaFacebookSquare/>
                                <FaLinkedinIn/>
                            </div>
                        </div>
                    </SlideLeft>
                </div>
                <div className='form-holder-sec'>
                    <div className='form-heading'>
                        <h3 className='form_head'>Get in Touch!</h3>
                        <p>Feel free to contact us for any query.</p>
                    </div>
                    <form>
                        <div className='field'>
                            {/* <label for="name">Name</label> */}
                            <input type={'text'} className="field_input" id="name" name='name' placeholder='Enter Your Name'/>
                        </div>
                        <div className='field'>
                            {/* <label for="email">Email</label> */}
                            <input type={'text'} className="field_input" id="email" name='email' placeholder='Enter Your Email'/>
                        </div>
                        <div className='field'>
                            {/* <label for="message">Message</label> */}
                            <textarea className="field_input" id="message" name='message' placeholder='Enter Your Message'></textarea>
                        </div>
                        <div className='submit_form'>
                            <button className='submit-button' type='submit'>Send</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Contact;